export const ERROR = 'REPORTS/ERROR';
export const FETCH = 'REPORTS/FETCH';
export const LOADING = 'REPORTS/LOADING';
export const EXPORT_LOADING = 'REPORTS/EXPORT_LOADING';
export const SET_DATA = 'REPORTS/SET_DATA';
export const SET_FILTER = 'REPORTS/SET_FILTER';
export const RESET_FILTER = 'REPORTS/RESET_FILTER';
export const EXPORT_REPORT = 'REPORTS/EXPORT_REPORT';
export const SET_PAGE = 'REPORTS/SET_PAGE';
export const SET_TOTAL_COUNT = 'REPORTS/SET_TOTAL_COUNT';
export const SET_DISC_APPROVAL_COUNT = 'REPORTS/SET_DISC_APPROVAL_COUNT';
export const FETCH_FILTERED_PROJECTS = 'REPORTS/FETCH_FILTERED_PROJECTS';
export const SET_FILTERED_PROJECTS = 'REPORTS/SET_FILTERED_PROJECTS';
export const SET_ALL_FILTERED_CLOSING_IDS = 'REPORTS/SET_ALL_FILTERED_CLOSING_IDS';
export const GENERATE_BULK_REPORT = 'REPORTS/GENERATE_BULK_REPORT';
export const BULK_REPORT_SUCCESS = 'REPORTS/BULK_REPORT_SUCCESS';
export const BULK_REPORT_ERROR = 'REPORTS/BULK_REPORT_ERROR';
export const CLEAR_BULK_REPORT_STATUS = 'REPORTS/CLEAR_BULK_REPORT_STATUS';

export const error = err => ({ type: ERROR, error: err });
export const fetch = () => ({ type: FETCH });
export const loading = isLoading => ({ type: LOADING, loading: isLoading });
export const exportLoading = isLoading => ({ type: EXPORT_LOADING, loading: isLoading });
export const setData = data => ({ type: SET_DATA, data });
export const setFilter = (filterKey, filterValue) => ({ 
  type: SET_FILTER, 
  filterKey, 
  filterValue 
});
export const resetFilter = () => ({ type: RESET_FILTER });
export const exportReport = (format, data) => ({ type: EXPORT_REPORT, format, data });
export const setPage = (page, rowsPerPage) => ({ type: SET_PAGE, page, rowsPerPage });
export const setTotalCount = count => ({ type: SET_TOTAL_COUNT, count });
export const setDiscApprovalCount = count => ({ type: SET_DISC_APPROVAL_COUNT, count });
export const fetchFilteredProjects = filters => ({ type: FETCH_FILTERED_PROJECTS, filters });
export const setFilteredProjects = data => ({ type: SET_FILTERED_PROJECTS, data });
export const setAllFilteredClosingIds = ids => ({ type: SET_ALL_FILTERED_CLOSING_IDS, ids });
export const generateBulkReport = (reportType, filters, selectedColumns) => ({ 
  type: GENERATE_BULK_REPORT, 
  reportType, 
  filters, 
  selectedColumns 
});
export const bulkReportSuccess = (reportType, selectedColumns) => ({
  type: BULK_REPORT_SUCCESS,
  reportType,
  selectedColumns
});
export const bulkReportError = (message) => ({
  type: BULK_REPORT_ERROR,
  message
});
export const clearBulkReportStatus = () => ({
  type: CLEAR_BULK_REPORT_STATUS
});
